var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrapper"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default"),_c('div',{staticClass:"extra"},[_vm._t("extra")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }